module.exports = __webpack_public_path__ + "images/chevrolet2177b18231ceb2e9afa25c31a0d89d6e.png";